import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';
import { AppUser }              from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const updateAppUserRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const updateAppUserSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{
  appUser: AppUser
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.appUser.id;
  state.entries = { ...state.entries, [payload.appUser.id]: payload.appUser };
};

export const updateAppUserFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
